import type {
  Configuration,
  QueryCostDataRequest,
  CostUnit,
} from '@repo/api-gw-sdk';
import { BillingApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/metering';

export const metering = (httpClient: HttpClient, config: Configuration) => {
  const billingApi = new BillingApi(config);

  return {
    useQueryCostData: (queryCostDataRequest: QueryCostDataRequest) =>
      httpClient.execute(
        billingApi.queryCostData.bind(billingApi),
        baseUrl,
        '',
        queryCostDataRequest
      ),
    useGetBillingTransactions: (
      startTime: Date,
      endTime: Date,
      costUnit: CostUnit
    ) =>
      httpClient.execute(
        billingApi.getBillingTransactionsWithPreview.bind(billingApi),
        baseUrl,
        '/billing-transactions',
        startTime,
        endTime,
        undefined,
        costUnit
      ),
    useGetAgreements: (costUnit: CostUnit) =>
      httpClient.execute(
        billingApi.getAgreements.bind(billingApi),
        baseUrl,
        '/agreements',
        costUnit
      ),
  };
};
